import { createAsyncThunk } from '@reduxjs/toolkit';
import { UnFormalizedZipResponseDto } from 'shared/api';
import { unFormalizedZipApi } from '../../api/unFormalizedZipApi';
import { UnFormalizedZipRequest } from '../types/types';

export const getAllUnFormalizedZips = createAsyncThunk(
  'unFormalizedZip/getAll',
  async (params: { company?: string; status?: UnFormalizedZipResponseDto.status }, { rejectWithValue }) => {
    try {
      const response = await unFormalizedZipApi.getUnFormalizedZips(null, params?.status);
      if (params.company) {
        return response.filter((item) => item.company === params.company);
      }
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getUnFormalizedZipById = createAsyncThunk(
  'unFormalizedZip/getById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await unFormalizedZipApi.getUnFormalizedZipById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getUnFormalizedZipsByEngineId = createAsyncThunk(
  'unFormalizedZip/getByEngineId',
  async (engineId: number, { rejectWithValue }) => {
    try {
      const response = await unFormalizedZipApi.getUnFormalizedZips();
      // Фильтруем по engineId на клиенте, так как API не поддерживает фильтрацию по engineId
      return response.filter((zip: { engineId: number }) => zip.engineId === engineId);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createUnFormalizedZip = createAsyncThunk(
  'unFormalizedZip/create',
  async (data: UnFormalizedZipRequest, { rejectWithValue }) => {
    try {
      const response = await unFormalizedZipApi.createUnFormalizedZip(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateUnFormalizedZip = createAsyncThunk(
  'unFormalizedZip/update',
  async ({ id, data }: { id: number; data: UnFormalizedZipRequest }, { rejectWithValue }) => {
    try {
      const response = await unFormalizedZipApi.updateUnFormalizedZip(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteUnFormalizedZip = createAsyncThunk(
  'unFormalizedZip/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await unFormalizedZipApi.deleteUnFormalizedZip(id);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
